import { onSelectedAccountChanged } from 'owa-account-source-list-store';
import { LazyAction, LazyModule, registerLazyOrchestrator } from 'owa-bundling';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "GroupList" */ './lazyIndex'));

// Delay loaded actions
export const lazyLoadGroups = new LazyAction(lazyModule, m => m.loadGroups);

export const lazyLoadGroupsFromSessionData = new LazyAction(
    lazyModule,
    m => m.loadGroupsFromSessionData
);

export const lazyRemoveGroupFromLeftNav = new LazyAction(lazyModule, m => m.removeGroupFromLeftNav);

export const lazyToggleGroupTreeExpansion = new LazyAction(
    lazyModule,
    m => m.toggleGroupTreeExpansion
);

export const lazyUnsubscribeFromUnreadNotifications = new LazyAction(
    lazyModule,
    m => m.unsubscribeFromUnreadNotifications
);

export const lazySetGroupLastVisitedTime = new LazyAction(
    lazyModule,
    m => m.setGroupLastVisitedTime
);

export const lazyUnSubscribeToGroupFolderHierarchyNotifications = new LazyAction(
    lazyModule,
    m => m.unsubscribeToGroupFolderHierarchyNotifications
);

export const lazyLoadGroupAccountSources = new LazyAction(
    lazyModule,
    m => m.loadGroupAccountSources
);

export const lazyLoadGroupAccountSourcesForCurrentSession = new LazyAction(
    lazyModule,
    m => m.loadGroupAccountSourcesForCurrentSession
);

// Register lazy orchestrator
registerLazyOrchestrator(onSelectedAccountChanged, lazyModule, m => m.lazyLoadGroupsOrchestrator);
